import React from 'react'
import PropTypes from 'prop-types'
import { Box, TextField, Typography } from '@material-ui/core'

import theme from 'theme'

import useCookieBanner from 'hooks/useCookieBanner'

import constants from 'constants/index'

const ButtonTextFields = ({
  label,
  desktopField,
  mobileField,
  desktopMaxLength,
  desktopPlaceholder,
  mobilePlaceholder,
}) => {
  const { BUTTON_MOBILE_TEXT_MAX_LENGTH } = constants.cookies.bannerTextOverride

  const { getBannerTextOverride, updateBannerTextOverride } = useCookieBanner()

  const desktopValue = getBannerTextOverride(desktopField) || ''
  const mobileValue = getBannerTextOverride(mobileField) || ''

  const textFields = [
    {
      field: desktopField,
      label: 'Texto desktop',
      value: desktopValue,
      placeholder: desktopPlaceholder,
      maxLength: desktopMaxLength,
    },
    {
      field: mobileField,
      label: 'Texto mobile',
      value: mobileValue,
      placeholder: desktopValue.trim() || mobilePlaceholder,
      maxLength: BUTTON_MOBILE_TEXT_MAX_LENGTH,
    },
  ]

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Typography variant="subtitle2">{label}</Typography>
      {textFields.map((textField) => (
        <TextField
          key={textField.field}
          fullWidth
          label={textField.label}
          value={textField.value}
          onChange={(event) =>
            updateBannerTextOverride(textField.field, event.target.value)
          }
          inputProps={{ maxLength: textField.maxLength }}
          helperText={`${textField.value.length}/${textField.maxLength}`}
          error={textField.value.length > textField.maxLength}
          InputLabelProps={{ shrink: true }}
          placeholder={textField.placeholder}
        />
      ))}
    </Box>
  )
}

ButtonTextFields.propTypes = {
  label: PropTypes.string.isRequired,
  desktopField: PropTypes.string.isRequired,
  mobileField: PropTypes.string.isRequired,
  desktopMaxLength: PropTypes.number.isRequired,
  desktopPlaceholder: PropTypes.string,
  mobilePlaceholder: PropTypes.string,
}

export default ButtonTextFields
